import script from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./VideoStylePanel.vue?vue&type=style&index=0&id=86b6dd42&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86b6dd42"]])

export default __exports__